import { CleaningDuration } from '@models/CleaningDuration';

import { fetchApi } from './fetchApi';

export async function getCleaningDurationByArea(token: string, area: number) {
  return fetchApi<CleaningDuration>('GET', `/cleaning-durations`, token, {
    query: { area },
  });
}
